import React, { memo, useEffect, useLayoutEffect, useState } from "react";
import "../../App.css";
import { Outlet, useNavigate } from "react-router-dom";
import {
  DocumentData,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";

import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import "nprogress/nprogress.css";
import { Drawer, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { getToken, onMessage } from "firebase/messaging";
import { useUserContext } from "../../contextapi/UserContext";
import { fetchPermissions } from "../../features/permissionsSlice";
import { auth, messaging, db } from "../../firebase/FirebaseCredential";
import { useAppSelector, useAppDispatch } from "../../hooks/hooks";
import useSessionSync from "../../hooks/SessionProvider";
import { RootState } from "../../store/store";
import { useChatContext } from "../ChatComponent/context/ChatContext";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { logError } from "../ErrorLogService/ErrorLoggingService";
import saveTokenToBenchProfile from "../UIComponent/NotificationReceiverComponent/FCMTokenToBenchProfile";
import RoleGuardProvider from "./RoleGuardProvider";
import { fetchBranches } from "../../features/branchSlice";
import { ROUTES } from "../../routes/routesPaths";


export default function AuthenticatedBlankLayout() {
  const isMobile = useMediaQuery(`(max-width: 768px)`);
    const {
      setProfileDetails,
      setRoleDetails,
      profileDetails,
      setCompanySetting,
      roleDetails,
    } = useUserContext();
    useSessionSync(); //! Ensures session persists on refresh
    const roleId = useAppSelector((state: RootState) => state.session.role_type);
    const [userId, setUserId] = useState(null);
    const [claimedData, setClaimedData] = useState<any>(null);
    // const [showModal, setShowModal] = useState(false);
    let navigate = useNavigate();
    // const [visible, { toggle }] = useDisclosure(true);
    const dispatch = useAppDispatch();
    const theme = useMantineTheme();
    const { state, actions, setChatDrawer, chatDrawer } = useChatContext();
    useEffect(() => {
      if (userId && roleId) {
        dispatch(fetchPermissions(roleId));
        dispatch(fetchBranches());
      }
  
      // return () => {
      //   dispatch(clearSubscription());
      // };
    }, [roleId, userId, profileDetails, dispatch]);
  
    useEffect(() => {
      if (userId) {
        if (!profileDetails || Object.keys(profileDetails).length === 0) {
          onRefreshCall();
        }
      }
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, profileDetails]);
    useLayoutEffect(() => {
      let uid;
      auth.onAuthStateChanged(async (user: any) => {
        if (user) {
          uid = user.uid;
          const tokenResult = await user.getIdTokenResult();
          const claims = tokenResult.claims;
          // console.log(claims, "claims");
          setClaimedData(claims);
          setUserId(uid);
          // console.log(uid, '556');
        } else {
          uid = null;
          // console.log("557", uid);
        }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const companyId = useAppSelector(
      (state: RootState) => state.session?.company_id
    );
  
    const requestPermission = React.useCallback(async () => {
      if (!("Notification" in window)) return;
      const permission = await Notification.requestPermission();
      if (permission === "granted" && messaging) {
        try {
          const token = await getToken(messaging, {
            vapidKey:
              "BBIY92tI4fYPZ775dCV0VvW7gLBc_g9kOMdNRCwdHXmHAVg3VwjZe3DtxCdUXzZXbiq22ltgQMoJs09iotfWbTQ",
          });
          if (!companyId) return;
          // console.log("FCM Token:", token);
          // saveTokenToFirestore(token, companyId); // Save token to Firestore
          if (!userId) return;
          saveTokenToBenchProfile(token, userId, companyId); // Save token to Firestore with userId
          // Save token to user's Firestore document to target push notifications
        } catch (err) {
          console.error("Permission denied or error getting token:", err);
        }
      } else {
        console.warn("🚫 Notification permission not granted");
      }
    }, [companyId, userId]);
    useEffect(() => {
      if (!companyId) return;
  
      requestPermission();
  
      // Foreground message listener
      // This assumes messaging is already initialized elsewhere
      if (messaging) {
        onMessage(messaging, (payload) => {
          console.log("Foreground FCM:", payload);
  
          const { title, body } = payload.notification || {};
  
          if (title && body) {
            // ✅ Show system push notification (manual for foreground)
            if (Notification.permission === "granted") {
              new Notification(title, {
                body,
                icon: "/icon.png", // optional
              });
            } else {
              // Optionally show a toast (like from react-hot-toast)
              toast(`${title}: ${body}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          } else {
            console.warn("Notification payload is missing.");
          }
        });
      }
    }, [companyId, requestPermission]);
  
    const onRefreshCall = async () => {
      // let userId = localStorage.getItem('userId');
      // console.log(auth?.currentUser?.uid, auth, userId, "555")
      try {
        // const docRef = doc(db, 'benchprofile', String(userId));
        const docRef = collection(db, "benchprofile");
        const q = query(docRef, where("uid", "==", userId));
        const querySnapshot = await getDocs(q);
  
        if (querySnapshot.size > 0) {
          const userData = querySnapshot.docs[0].data();
          setProfileDetails(userData);
  
          const tempID = querySnapshot.docs[0].id;
          const benchprofileDocRef = doc(db, "benchprofile", tempID);
          const rolesCollectionRef = collection(benchprofileDocRef, "roles");
          const rolesQ = query(rolesCollectionRef, where("uid", "==", userId));
          const rolesQuerySnapshot = await getDocs(rolesQ);
          // const rolesQuerySnapshot = await getDocs(rolesCollectionRef);
          await updateDoc(benchprofileDocRef, {
            status: "active",
            status_last_changed: serverTimestamp(),
          });
          let rolesData: DocumentData[] = [];
  
          rolesQuerySnapshot.forEach((doc) => {
            rolesData.push(doc.data());
          });
          if (rolesQuerySnapshot.size === 0) {
            if (claimedData?.super_admin) {
              // setShowModal(true);
              console.log("Super admin with no roles found, redirecting...");
              console.log("No roles found, redirecting...");
             navigate("/choose/companytype");
              return;
            } else {
              console.log("No roles found");
              toast.error("No roles found. Please contact support.");
              await signOut(auth);
            }
          }
          const companyAdminTrue = rolesData.find(
            (item) => item.roles.company_admin === true
          );
  
          // const branchAdminTrue = rolesData.find(
          //   (item) => item.roles.branch_admin === true
          // );
          // if (!companyAdminTrue && !branchAdminTrue) {
          //   console.log("No branch or company admin found, redirecting...");
          //   navigate("/newcompanyregistration"); // Redirect to new company registration page
          //   return;
          // }
          if (companyAdminTrue) {
            setRoleDetails(companyAdminTrue.roles);
          } else {
            // Remove documents that don't have branch_id
            rolesData = rolesData.filter((doc) => doc.branch_id);
  
            // Remove duplicates (keeping only one per company_id per role_type)
            const uniqueRolesData: DocumentData[] = [];
            const seen = new Set();
            for (const doc of rolesData) {
              const key = `${doc.company_id}-${doc.role_type}`;
              if (!seen.has(key)) {
                seen.add(key);
                uniqueRolesData.push(doc);
              }
            }
  
            if (uniqueRolesData.length === 1) {
              // localStorage.setItem("company_id", uniqueRolesData[0].company_id);
              // localStorage.setItem("branch_id", uniqueRolesData[0].branch_id);
              setRoleDetails(uniqueRolesData[0].roles);
              console.log(uniqueRolesData[0].roles, "uniqueRolesData[0].roles");
  
              // navigate("/home");
            }
          }
        } else {
          console.log("User data not found");
        }
      } catch (error) {
        console.log("Error getting user data:", error);
        logError(error, "onRefreshCall App");
      } finally {
        // console.log("end of user data check");
      }
    };
  return (
    <ErrorBoundary>
      <RoleGuardProvider
        companyId={companyId}
        userId={auth?.currentUser?.uid}
        userClaims={claimedData}
      >
        <div className="PrivateLayout">
          <main>
            <Outlet />
          </main>
       
        </div>
      </RoleGuardProvider>
    </ErrorBoundary>
  );
}
